// extracted by mini-css-extract-plugin
export var externalLink = "_fc-0";
export var internalLinkLabel = "_fc-1";